import React from 'react';
import styled from 'styled-components';
import { Box, } from '@waglabs/box-next';
const IconButton = ({ children, disabled, onClick, ...rest }) => (React.createElement(Box, Object.assign({ as: "button", alignItems: "center", background: "none", border: "none", borderRadius: "50%", cursor: "pointer", disabled: disabled, display: "inline-flex", fontSize: "24px", fontFamily: "muli", justifyContent: "center", outline: "none", p: "12px", textDecoration: "none" }, onClick && {
    onClick: (event) => {
        /**
         * TypeScript cannot infer the correct typing when it is applying polymorphism (ex: as="button")
         */
        onClick(event);
    },
}, rest),
    React.createElement(Box, { as: "span", color: "inherit", cursor: "inherit", display: "flex", fontFamily: "inherit", fontSize: "inherit", fontWeight: "inherit", lineHeight: "inherit" }, children)));
const StyledIconButton = styled(IconButton) `
  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 1;
  }

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }

  &:disabled {
    opacity: 0.26;
  }
`;
export { StyledIconButton as IconButton };
